import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import z from 'zod';
import { coerceBoolean, coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import { MlmTwilightPhotoType } from './MlmPhotosTwilight';

export enum MlmPhotosType {
  STANDARD = 'standard',
  TWILIGHT = 'twilight',
  RESHOOT = 'reshoot',
  EXTERIOR = 'exterior',
  EVENT = 'event',
  PARTIAL = 'partial'
}

export enum MlmPhotosDetailTime {
  MINUTES_15 = '15',
  MINUTES_30 = '30',
}

export default createPerformableConfig(
  'photos',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      type: z.nativeEnum(MlmPhotosType),

      extra_photos_max: z.coerce.number().optional(),
      extra_photos_actual: z.coerce.number().optional(),

      hours: z.coerce.number().optional(),

      instructions: z.string().optional(),

      detail: z.nativeEnum(MlmPhotosDetailTime).optional(),
      detail_notes: z.string().optional(),

      community: coerceBoolean().optional(),
      community_notes: z.string().optional(),

      photos: z.coerce.number().optional(),
      twilight_type: z.nativeEnum(MlmTwilightPhotoType).optional(),
      twilight_photos: z.coerce.number().optional(),
    }),
  },
  {
    name: 'Photography',
    thumbnail: '/tenant/mpi/residential/1.jpg',
    images: [],
    short: 'Our most popular service! Includes 36 photos, delivered in 24 hours or less!',
    tenant: TenantId.MAINE_LINE_MEDIA,
    group: 'Digital Media',
  },
);
